import { Injectable } from "@angular/core";
import { BaseService } from "@common-modules/shared/base.service";

@Injectable()
export class CTResultsFormatService extends BaseService {

    mergeDataWithAdditionalColumns(
        data: { [property: string]: string }[],
        additionalColumnsByScenario: { [scenarioId: string]: { [property: string]: string }[] }[]
    ): { [property: string]: string }[] {

        return data.map(item => {
            const scenarioId = item.scenarioId;
            const scenarioData = additionalColumnsByScenario[scenarioId];

            if (scenarioData) {
                const additionalColumns = scenarioData.reduce((acc, valueObj) => {
                    const itemKeys = Object.keys(item);

                    const filteredColumns: { [key: string]: string } = {};

                    Object.keys(valueObj).forEach(key => {
                        if (key.endsWith('_units') || key.endsWith('_format')) {

                            const basePropertyName = key.replace(/_(units|format)$/, '');

                            if (itemKeys.includes(basePropertyName)) {
                                filteredColumns[key] = valueObj[key];
                            }
                        }
                    });

                    return { ...acc, ...filteredColumns };
                }, {});

                return { ...item, ...additionalColumns };
            }

            return item;
        });
    }
}